import React, { useState } from "react";
import { PageHeader } from "antd";
import JcpEnrollmentEntry from "../../components/enrollment/jcp/JcpEnrollmentEntry";
import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import JcpEnrollmentEntryMonthly from "../../components/enrollment/jcp/JcpEnrollmentEntryMonthly";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import HpEnrollmentEntryMonthly from "../../components/enrollment/hp/HpEnrollmentEntryMonthly";

const HpEnrollmentMonthly = () => {
  const params = useParams();
  const [heading,setHeading] = useState("");

  useEffect(()=>{
    if(params.billtype){
      params.billtype == "gst" ? setHeading("Monthly Subscription HP Or JHP (GST)") : setHeading("Monthly Subscription HP Or JHP (NON-GST)");
    }
  },[params.billtype]);
 

  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title={heading}
          subTitle=""
          extra={[]}
        ></PageHeader>

        <HpEnrollmentEntryMonthly />
      </div>
    </div>
  );
};

export default HpEnrollmentMonthly;
